/**
 * Detects whether this Vue WebApp shell is running embedded inside the Back-Office.
 *
 * The BO loads the WebApp as a sibling frame (`frameWA`) under a top shell frameset to
 * display visit history later (see boMessageRelay.js for the full frameset layout).
 * Standalone (mobile/tablet, or direct desktop access to m.*), the WebApp IS the top-level
 * window, so being framed at all is a reliable "embedded in BO" signal — the WebApp shell
 * has no other known embedder.
 *
 * @returns {boolean}
 */
export function isEmbeddedInBackOffice() {
	try {
		return window.self !== window.top;
	} catch {
		// Cross-origin access to window.top is blocked → we're inside a frame we don't own,
		// which for this app means the Back-Office. Treat as embedded.
		return true;
	}
}
